const initialState = null 
  
  const settingsReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_SETTINGS':
        return action.payload;
  
      case 'CLEAR_SETTINGS':
        return null;
  
      default:
        return state;
    }
  };
  
  export default settingsReducer;
  